import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ServiceStatisticMiniEntity } from '../../domain/entities/ServiceStatisticMiniEntity'
import type { ServiceStatisticAdminDto } from '@/backend/market'
import moment from 'moment'
import { ServiceStatisticType } from '../../domain/enums/ServiceStatisticType'

export class ServiceStatisticMiniModel extends ServiceStatisticMiniEntity {
  constructor(dataDto: ServiceStatisticAdminDto, type?: ServiceStatisticType) {
    super()
    mapEntityProperties<ServiceStatisticMiniEntity>(this, dataDto, {
      map: {
        date: moment(dataDto.date).format(getFormatDate(type))
      }
    })
  }
}

function getFormatDate(type?: ServiceStatisticType) {
  switch (type) {
    case ServiceStatisticType.DAILY:
      return 'DD/MM/YYYY '
    case ServiceStatisticType.MONTHLY:
      return 'MM/YYYY'
    case ServiceStatisticType.HOURLY:
      return 'DD/MM/YYYY HH:mm:ss'
    default:
      return 'DD/MM/YYYY HH:mm:ss'
  }
}
